import axios from 'axios'

export default {
    getCoffees() {
        return axios.get('/coffee/v1')
            .then(response => {
                return response.data
            })
    }
}